import React from "react";
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";
import { TransactionHistory } from "./TransactionHistory";
import { WalletDashboard } from "./WalletDashboard";
import { AddMoney } from "./AddMoney";
import { ManageSubscriptions } from "./ManageSubscriptions";
import { getSession } from "../../../redux/actions/authActions";
import { useParams } from "react-router-dom";

const EWallet = ({ isAdmin }) => {
  const { user_profile_id } = getSession();
  const { userId } = useParams();

  const id = isAdmin ? userId : user_profile_id;

  return (
    <div className="min-h-screen bg-gray-100">
      {!isAdmin && (
        <Header
          pageTitle="My eWallet"
          icon={
            <Icon icon="material-symbols-light:account-balance-wallet-outline" />
          }
        />
      )}
      <div className="p-6 grid gap-6 md:grid-cols-12 lg:grid-cols-12">
        <div className="bg-white shadow-sm rounded-2xl col-span-12 overflow-auto sm:h-[40vh] max-h-max ">
          <WalletDashboard />
        </div>

        {!isAdmin && (
          <div className="bg-white shadow-sm rounded-2xl col-span-12 overflow-auto sm:h-[40vh] max-h-max ">
            <AddMoney />
          </div>
        )}
        <div className="bg-white shadow-sm rounded-2xl col-span-12 sm:col-span-6 overflow-auto h-[50vh] max-h-max ">
          <TransactionHistory
            redirectionUrl="/dashboard/wallet/transactions"
            userId={id}
          />
        </div>

        <div className="bg-white shadow-sm rounded-2xl col-span-12 sm:col-span-6 overflow-auto h-[50vh] max-h-max ">
          <ManageSubscriptions
            redirectionUrl="/dashboard/wallet/subscriptions"
            userId={id}
          />
        </div>
      </div>
    </div>
  );
};

export default EWallet;
